__turbopack_context__.v({
  "host": "Hosts-module-scss-module__ssajuW__host",
  "name": "Hosts-module-scss-module__ssajuW__name",
});
